import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  button: {
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    marginRight: 0,
    '@media (min-width:992px)': {
      marginRight: 0,
    },
    minWidth: 'unset',
    maxWidth: 160,
    color: "#904d71",
    fontSize: 12,
    fontFamily: "'Montserrat', sans-serif",
    fontWeight: 600,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'inline-flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    position: 'relative',
    zIndex: 1001,
    textTransform: 'none',
    letterSpacing: '0.02em',
    lineHeight: 1.4,
    border: 'none',
    borderRadius: '9999px',
    background: 'transparent',
    boxShadow: 'none',
  },
  modernMenu: {
    "& .MuiPaper-root": {
      background: "rgba(255, 255, 255, 0.98)",
      backdropFilter: "blur(20px)",
      WebkitBackdropFilter: "blur(20px)",
      borderRadius: "16px",
      border: "1px solid rgba(144, 77, 113, 0.1)",
      boxShadow: "0 12px 40px 0 rgba(144, 77, 113, 0.15)",
      minWidth: "200px",
      marginTop: "8px",
      zIndex: 1300,
    },
    "& .MuiList-root": {
      padding: "12px 8px",
    },
  },
  menuItem: {
    borderRadius: "12px",
    margin: "4px 0",
    padding: "14px 18px",
    fontSize: "14px",
    fontFamily: "'Jost', sans-serif",
    fontWeight: 500,
    color: "#904d71",
    background: "rgba(144, 77, 113, 0.05)",
    border: "1px solid rgba(144, 77, 113, 0.1)",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    "&:hover": {
      background: "rgba(144, 77, 113, 0.1)",
      backdropFilter: "blur(8px)",
      WebkitBackdropFilter: "blur(8px)",
      transform: "translateY(-2px)",
      boxShadow: "0 6px 20px 0 rgba(144, 77, 113, 0.2)",
      border: "1px solid rgba(144, 77, 113, 0.2)",
    },
    "&:active": {
      transform: "translateY(0px)",
    },
  },
  adminMenuItem: {
    borderRadius: "10px",
    margin: "3px 0",
    padding: "10px 14px",
    fontSize: "13px",
    fontFamily: "'Jost', sans-serif",
    fontWeight: 600,
    color: "#8e44ad",
    background: "linear-gradient(135deg, rgba(142, 68, 173, 0.1), rgba(155, 89, 182, 0.05))",
    border: "1px solid rgba(142, 68, 173, 0.1)",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      background: "linear-gradient(135deg, rgba(142, 68, 173, 0.15), rgba(155, 89, 182, 0.1))",
      backdropFilter: "blur(8px)",
      WebkitBackdropFilter: "blur(8px)",
      transform: "translateY(-2px)",
      boxShadow: "0 6px 20px 0 rgba(142, 68, 173, 0.3)",
      border: "1px solid rgba(142, 68, 173, 0.2)",
    },
    "&:active": {
      transform: "translateY(0px)",
    },
  },
  logoutMenuItem: {
    borderRadius: "10px",
    margin: "3px 0",
    padding: "10px 14px",
    fontSize: "13px",
    fontFamily: "'Jost', sans-serif",
    fontWeight: 500,
    color: "#e74c3c",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      background: "rgba(231, 76, 60, 0.08)",
      backdropFilter: "blur(8px)",
      WebkitBackdropFilter: "blur(8px)",
      transform: "translateY(-2px)",
      boxShadow: "0 4px 16px 0 rgba(231, 76, 60, 0.2)",
    },
    "&:active": {
      transform: "translateY(0px)",
    },
  },
}));

export default useStyles;
